// @flow
import React, { Fragment, useState } from 'react';
import { FormikProvider } from "formik";
import { useTranslation } from "react-i18next";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
// import { Google } from "@mui/icons-material";
import {
	Grid,
	OutlinedInput,
	Stack,
	FormHelperText,
	Link,
	Typography,
	Button,
	InputAdornment,
	IconButton
} from "@mui/material";
import { Capacitor } from "@capacitor/core";
// import useUserAction from "../../hooks/user/useUserAction";
// import useUserData from "../../hooks/user/useUserData";
import { getRouteUrl } from "../../helpers/getRouteUrl";
import { ROUTE_PAGE_SIGN_UP, ROUTE_PAGE_RESET_PASS, ROUTE_PAGE_HOME } from "../../routers/routes";
import { Link as RouterLink } from 'react-router-dom'
import VisibleEyeOff from "../../assets/images/icons/login/visibleEyeOff";
import VisibleEyeOn from "../../assets/images/icons/login/visibleEyeOn";
import EmailIcon from "../../assets/images/icons/login/emailIcon";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import Divider from "@mui/material/Divider";

type Props = {
	formik: Object
};

export const LoginForm = ({ formik, loading, handleBiometricLogin, isLoginOneTime }: Props) => {
	const { t } = useTranslation(PAGE_LOGIN)
	// const { googleLogin } = useUserAction()
	// const { language } = useUserData()
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);

	// async function googleNativeLogin() {
	// 	const result = await GoogleAuth.signIn();
	// 	if (result) googleLogin({
	// 		credential: result?.authentication?.idToken,
	// 		clientId: '',
	// 		select_by: ''
	// 	})
	// }
	
	return (
		<Fragment>
			<FormikProvider value={formik}>
				<form onSubmit={formik.handleSubmit} noValidate autoComplete="off">
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Stack spacing={1}>
								<OutlinedInput
									id="username"
									value={formik.values.username}
									name="username"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									placeholder={t("Email")}
									fullWidth
									error={Boolean(formik.touched.username && formik.errors.username)}
									autoComplete={'username'}
									className='border-neutral-dark-radius'
									sx={{ minHeight: 'unset' }}
									startAdornment={
										<InputAdornment
											position="start"
											sx={{ bgColor: '#FFFFFF' }}>
											<EmailIcon />
										</InputAdornment>
									}
									inputProps={{
										style: {
											fontSize: '14px',
											padding: '10px',
											minHeight: 'unset'
										},
									}}
								/>
								{formik.touched.username && formik.errors.username && (
									<FormHelperText error id="standard-weight-helper-text-email-login">
										{formik.errors.username}
									</FormHelperText>
								)}
							</Stack>
						</Grid>
						<Grid item xs={12}>
							<Stack spacing={1}>
								<OutlinedInput
									fullWidth
									error={Boolean(formik.touched.password && formik.errors.password)}
									id="password"
									type={showPassword ? 'text' : 'password'}
									value={formik.values.password}
									name="password"
									onBlur={formik.handleBlur}
									onChange={formik.handleChange}
									autoComplete={'current-password'}
									className='border-neutral-dark-radius'
									startAdornment={
										<InputAdornment position="start">

											{showPassword ? <VisibleEyeOn onClick={handleClickShowPassword} /> : <VisibleEyeOff onClick={handleClickShowPassword} />}

										</InputAdornment>
									}
									sx={{ minHeight: 'unset' }}
									inputProps={{
										style: {
											fontSize: '14px',
											padding: '10px',
											minHeight: 'unset'
										},
									}}
									placeholder={t("Password")}
								/>
								{formik.touched.password && formik.errors.password && (
									<FormHelperText error id="standard-weight-helper-text-password-login">
										{formik.errors.password}
									</FormHelperText>
								)}
							</Stack>
						</Grid>
						{/*TODO::Hide google login*/}
						{/*{!(Capacitor.getPlatform() === 'ios') && (
							<Grid item xs={12}>
								<Stack spacing={1}>
									{Capacitor.getPlatform() === 'android' ? (
										<Button onClick={googleNativeLogin} size={'large'}>
											<Google/>{t("Sign in with Google")}
										</Button>
									) : (
										<GoogleLogin
											width={matchDownMD ? '280px' : '345px'}
											size="large"
											//shape="circle"
											onSuccess={credentialResponse => {
												googleLogin(credentialResponse)
											}}
											
											onError={(error) => {
												
											}}
											useOneTap
											theme={'filled_white'}
											locale={language}
										/>
									)}
								</Stack>
							</Grid>
						)}*/}
						<Grid item xs={12} textAlign={'center'}>
							<Button
								disableElevation
								disabled={loading}
								fullWidth
								type="submit"
								sx={{ p: '14px 0' }}
								size={"small"}
								variant={"contained"}
								className='button-primary'
							>
								{t('Login')}
							</Button>
						</Grid>
						<Grid item xs={12} sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}>
							<Typography variant="h5" sx={{ margin: '10px 0' }} component="span">
								<Link
									component={RouterLink}
									variant="h5"
									to={getRouteUrl(ROUTE_PAGE_SIGN_UP)}
									underline="hover"
									className='color-default p-sm'
								>
									{t('Sign Up')}
								</Link>
							</Typography>
							<Link
								className='color-secondary p-sm'
								variant="h5"
								component={RouterLink}
								to={getRouteUrl(ROUTE_PAGE_RESET_PASS)}
								color="text.primary"
								sx={{ marginBottom: '16px' }}
							>
								{t("Forgot password?")}
							</Link>
							<Divider
								orientation="vertical"
								flexItem
								sx={{
									borderTop: '1px solid #eaeef7;',
									marginBottom: '16px'
								}}
							/>
							<Typography variant="h5" sx={{ margin: '0 0 20px 0' }} component="span">
								<Link
									component={RouterLink}
									variant="h5"
									to={getRouteUrl(ROUTE_PAGE_HOME)}
									underline="hover"
									className='color-default p-sm flex-center'
								>
									<ArrowBackIosNewIcon fontSize="small" sx={{  marginRight: '6px', width: '10px'}} /> {t('Return')}
								</Link>
							</Typography>
						</Grid>
						{Capacitor.isNativePlatform() && isLoginOneTime &&
							<>
								<Grid item xs={12} textAlign={'center'}>
									{t('Sign in with your biometrics')}
								</Grid>
								<Grid item xs={12} textAlign={'center'} sx={{p: 1}}>
									<IconButton size={"large"} onClick={handleBiometricLogin}>
										<FingerprintIcon sx={{ fontSize: 50 }} />
									</IconButton>
								</Grid>
							</>
						}
					</Grid>
				</form>
			</FormikProvider>
		</Fragment>
	);
};